import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'

export class Main extends AbstractView {
    constructor(domElementId) {
        return super(domElementId);
    }

    init() {
        const TextAndCounter = () => import(/* webpackChunkName: "airbus-page" */ 'components/SnippetTemplate/Items/TextAndCounter')
        new Vue({
            el: "#" + this.elemId,
            store,
            render: h => h(TextAndCounter, {props: eval(this.elemId)})
        })
    }
}
